function iniate_cell(){
    let active_cell = document.querySelectorAll('.product-recently-viewed .product-grid.carousel li')[0];
    if(active_cell)
    {
        let media = active_cell.querySelector('.card_media .media');
        let progress_bar_elem = create_progress_bar(media);
        flcty_auto_play(media,progress_bar_elem);
    }
}

 // Determine if an element is in the visible viewport
 function isInViewportRecently(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
    );
}

function create_progress_bar(media){
    const progress_bar_elem = document.createElement("div");
    progress_bar_elem.classList.add('progress-bar');
    let cell_time = cell_period(media);
    progress_bar_elem.style.animationDuration = cell_time + 's';
    media.appendChild(progress_bar_elem);
    return progress_bar_elem;
}

function remove_progress_bar(media){
    let progress_bar = media.querySelector('.progress-bar');
    if(progress_bar)
        progress_bar.remove();
}

function cell_period(media){
    let media_count = media.getAttribute('data-img');
    let cell_time = media_count * 1.5;
    return cell_time;
}

function flcty_auto_play(media, progress_bar_elem){
    const cell_id = media.getAttribute('data-id');
    const $flkty = Flickity.data('.product-recently-viewed .card_media  .media_'+cell_id+'.carousel');
    $flkty.options.autoPlay = 1500;
    $flkty.playPlayer();
}

function flcty_stop_auto_play(media){
    const cell_id = media.getAttribute('data-id');
    const $flkty = Flickity.data('.product-recently-viewed .card_media  .media_'+cell_id+'.carousel');
    $flkty.stopPlayer();
    $flkty.select(0);
}

